import React from "react";
import { Skeleton } from "@material-ui/lab";

export function VendorRatingSkeleton(props) {
  const JSX = (
    <>
      <div className="row">
        <div className="col-sm-12 col-md-12">
          <div className="mb-4">
            <Skeleton height="5rem" variant="rect" animation="wave" />
          </div>
          <div className="mb-4">
            <Skeleton height="8rem" variant="rect" animation="wave" />
          </div>

          <div className="mb-4">
            <Skeleton height="8rem" variant="rect" animation="wave" />
          </div>
          <div className="mb-4">
            <Skeleton height="2rem" variant="rect" animation="wave" />
          </div>
        </div>
      </div>
    </>
  );
  return JSX;
}
